import translation from 'locales/translation';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { PautaEvento } from 'api/Assessor/pautas';

import { LocationIcon } from 'components/Icons';
import {
  Button,
  ButtonThemes,
  ScreenSize,
} from 'plataforma-fundacao-componentes';

import { AssembleiaStatus } from 'helpers/enums/AssembleiaStatus';

import { IAssembleiasAssessorEvent } from 'store/modules/AssembleiasAssessorReducer';
import { IAuthUserReducer } from 'store/modules/AuthReducer';

import { getUniqueKey } from 'helpers/utils/KeyUtils';

import { ComputeVotes } from 'components/Modal/ComputeVotes';
import { AssemblyModalitiesNumber } from 'helpers/enums/Assembleia';
import { closeModal, openModal } from 'store/modules/ModalActions';
import { AuthUserPerfilId } from 'store/modules/auth/IAuthUserPerfil';
import useStyle from '../style';

interface Props {
  pauta: PautaEvento;
  evento: IAssembleiasAssessorEvent;
  usuario: IAuthUserReducer;
}

export default function VotoPresencialAction({
  pauta,
  evento,
  usuario,
}: Props) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const isReadOnly = useMemo(() => {
    if (usuario?.perfil.id === AuthUserPerfilId.PertencerConsulta) {
      return true;
    }

    return false;
  }, [usuario?.perfil.id]);

  const canShow = useMemo(() => {
    return (
      usuario.perfil.assessorRoute.assembleias.pautas.incluirVotoManual &&
      evento.modo === AssemblyModalitiesNumber.HIBRIDO_PRESENCIAL_DIGITAL &&
      evento.dataBloqueio !== null &&
      evento.status <= AssembleiaStatus.Pre
    );
  }, [usuario, evento]);

  const openComputarVotoPresencial = useCallback(() => {
    const modalKey: string = getUniqueKey();
    dispatch(
      openModal(ComputeVotes, {
        idPauta: pauta.idPauta,
        modalKey: modalKey,
        preventEscExit: true,
        preventMaskExit: true,
        mobileOn: ScreenSize.xs,
        titlePauta: pauta.titulo,
        title: translation.ComputeVotes.votacaoPresencialTitle,
        eventType: 'AGN',
        isReadOnly: isReadOnly,
        onClose: () => {
          dispatch(closeModal(modalKey));
        },
        onConfirm: () => {
          return new Promise<void>((resolve: any) => {
            resolve();
            dispatch(closeModal(modalKey));
          });
        },
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, pauta]);

  if (!canShow) {
    return null;
  }

  return (
    <Button
      className={[classes.botaoAcoes, classes.botaoVotoPresencial].join(' ')}
      theme={ButtonThemes.PrimaryLight}
      onClick={openComputarVotoPresencial}
      leftIcon={<LocationIcon />}
      disabled={isReadOnly}
    >
      {translation.AssembleiaPauta.acoes.computarVotoPresencial}
    </Button>
  );
}
